import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Layout from "./layout/Layout";
import AboutUs from './pages/AboutUs';
import Exploration from './pages/Exploration';
import Tokenization from './pages/tokenization';
import Presale_Token from './pages/presale';
import Roadmap from './pages/roadmap';
import Blogs from './pages/blogs';
import Contact_Us from './pages/contact_Us';
import Investor_Portal from './pages/investor_Portal';
import TermsAndConditions from './pages/terms&conditions';
import PrivacyPolicy from './pages/privacyPolciy';
import CookiePolicy from './pages/cookiePolicy';
import BlogDetail from './components/blogs/BlogDetail';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Routes with Layout */}
        <Route
          element={<Layout />}
        >
          <Route path="/" element={<Home />} />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/exploration" element={<Exploration />} />
          <Route path="/tokenization" element={<Tokenization />} />
          {/* <Route path="/market_Opportunity" element={<Market_Opportunity />} /> */}
          <Route path="/presale_Token" element={<Presale_Token />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/contact_Us" element={<Contact_Us />} />
          <Route path="/investor_Portal" element={<Investor_Portal />} />
        </Route>

        {/* Route without Layout */}
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/cookiePolicy" element={<CookiePolicy />} />
        <Route path="/blog/:id" element={<BlogDetail />} />

      </Routes>
    </Router>
  );
};

export default App;
